export default __webpack_public_path__ + "static/Heaphy-Track-credit-ChristophStrssler-1ee5dc63b61f9aaa21f72b164407aab2.jpg";